import React, { useState } from "react";
import "../../style/EventIndicator.css";
import moment from "moment";
import ViewEventModal from "./ViewEventModal";

const EventIndicator = ({ event, onDelete, onUpdate, tags  }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const formattedTime = moment(event.event_time, "HH:mm:ss").format("h:mm A");
  // Truncate the title with elipses. max length 15 chars.
  const truncatedTitle =
    event.title.length > 15
      ? event.title.substring(0, 12) + "..."
      : event.title;
  const isToday = moment(event.event_date).isSame(moment(), "day");

  return (
    <>
      <div 
        className={`event-indicator ${isToday ? "today-event" : ""}`}
        onClick={() => setIsModalOpen(true)}
        style={{ backgroundColor: event.tag_color || "#3282B8" }}
      >
        <span className="event-time">{formattedTime}</span>
        <span className="event-title">{truncatedTitle}</span>
      </div>

      <ViewEventModal 
        isOpen={isModalOpen} 
        event={event} 
        onClose={() => setIsModalOpen(false)} 
        onDelete={onDelete}
        onUpdate={onUpdate}
        tags={tags}
      />
    </>
  );
};

export default EventIndicator;